import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b836cc9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-info nongfu-button-wrap xag-page__footer" }
const _hoisted_2 = {
  key: 0,
  class: "loading-cover"
}
const _hoisted_3 = {
  key: 1,
  class: "main"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "insurance-info van-hairline--bottom" }
const _hoisted_6 = { class: "device-info-wrap van-hairline--bottom" }
const _hoisted_7 = { class: "info-list" }
const _hoisted_8 = { class: "total-wrap" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label total-label" }, "预计退款金额", -1))
const _hoisted_10 = { class: "value total-price" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " 注：退保申请服务由平安保险提供，预计退款金额不代表最终退款金额，实际退款金额以平安公司实际退款为准！退款预计将于1-3个工作日内退还，如有问题请咨询400-95511 ", -1))

import { useRouter } from 'vue-router'
import { Popup, Button, Loading } from 'vant'
import { getThousandMoney } from '@/utils/index'
import { useWatchPropsItem } from '@/compositions/useWatch'
import { getJijiaOrderRefundPrice, requestJijiaInsuranceRefund } from '@/apis/insurance'
import { withDefaults, ref, ComputedRef, computed } from 'vue'
import { JijiaDeviceCardInfoListItem, ClientJijiaInsuranceListItem } from '@/types/insurance'

import DeviceCardInfo from './device-card-info.vue'
import { clearToast, showToastLoading, showConfirmModal, showToastSuccess } from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'jijia-refund-popup',
  props: {
    show: { type: Boolean, default: false },
    detail: null
  },
  emits: ['update:show', 'updateList'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, detail?: ClientJijiaInsuranceListItem };


const $router = useRouter()
const refundPrice = ref('')
const loading = ref(false)

let prevRequestPolicyNo = ''
const deviceInfo: ComputedRef<JijiaDeviceCardInfoListItem | null> = computed(() => {
  if (!props.detail) {
    return null
  }
  return {
    sn: props.detail.eq_sn,
    headInfo: {
      name: props.detail.eq_name || props.detail.eq_model_name,
      img: props.detail.eq_logo,
      mainInfos: [`SN：${props.detail.eq_sn}`, `型号：${props.detail.eq_model_name}`],
    },
    // detailInfos: [getActiveTimeInfo(props.detail.eq_activate_time)],
  }
})

function getInsuranceName(type: number): string {
  // 产品类型：1、基础版 2、进阶版
  if (type === 1) {
    return '基础版'
  }
  if (type === 2) {
    return '进阶版'
  }
  return ''
}
function hidePopup() {
  emits('update:show', false)
}
async function confirmRefund() {
  if (props.detail.operation.operation_status === 0) {
    // 不可操作的情况
    showConfirmModal({
      title: '申请退保失败',
      message: props.detail.operation.message,
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
      showCancelButton: false,
    })
    return
  }
  try {
    await showConfirmModal({
      message: '退保后将立即失效，无法再使用保险服务，确定退保?',
      className: 'repair-dialog',
      confirmButtonText: '确定退保',
    })
  } catch (error) {
    return
  }
  showToastLoading()
  try {
    await requestJijiaInsuranceRefund({
      policy_no: props.detail.policy_no,
    })
    clearToast()
    showToastSuccess('退保成功')
    emits('update:show', false)
    emits('updateList')
  } catch (error) {
    const errorObj = error as { message: string }
    clearToast()
    showConfirmModal({
      title: '申请退款失败',
      message: errorObj?.message || '',
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
      showCancelButton: false,
    })
  }
}
useWatchPropsItem(props, 'show', () => {
  if (!props.show) {
    return
  }
  if (!props.detail || props.detail.policy_no === prevRequestPolicyNo) {
    return
  }
  initDeviceInsuranceInfo()
})
async function initDeviceInsuranceInfo() {
  loading.value = true
  try {
    const data = await getJijiaOrderRefundPrice(props.detail.policy_no)
    console.log('data', data)
    prevRequestPolicyNo = props?.detail?.policy_no
    refundPrice.value = getThousandMoney(Math.abs(parseFloat(data.actual_premium_change)))
  } catch (error) {
    const errorObj = error as { message: string }
    // showNormalToast(errorObj?.message || '获取退款失败')
    let message = errorObj?.message || '获取退款信息失败'
    const startIndex = message.indexOf('{')
    if (startIndex !== -1) {
      try {
        const jsonStr = message.slice(startIndex)
        const parseInfo = JSON.parse(jsonStr)
        message = parseInfo.data.responseMsg
      } catch (error) {
        console.log('error', error)
      }
    }
    await showConfirmModal({
      title: '提示',
      message,
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
      showCancelButton: false,
    })
    hidePopup()
  }
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popup), {
    show: props.show,
    position: "bottom",
    class: "custom-popup-border-radius",
    onClickOverlay: hidePopup,
    onClickCloseIcon: hidePopup
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Loading))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", { class: "head-info" }, [
          _createTextVNode("申请退款 "),
          _createElementVNode("i", { onClick: hidePopup })
        ]),
        (__props.detail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, " 意外机损保险-" + _toDisplayString(getInsuranceName(props?.detail?.product_info.pro_type)), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, "保单号：" + _toDisplayString(props?.detail?.policy_no), 1),
                _createElementVNode("div", null, "投保时间：" + _toDisplayString(props?.detail?.created_at?.split(' ')[0]), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_unref(deviceInfo))
                  ? (_openBlock(), _createBlock(DeviceCardInfo, {
                      key: 0,
                      data: _unref(deviceInfo),
                      imgSize: 72,
                      class: "custom-card-info"
                    }, null, 8, ["data"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(_toDisplayString(refundPrice.value), 1)
                  ])
                ])
              ]),
              _hoisted_12
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(Button), {
          class: "next-button xa-vant-button",
          round: "",
          onClick: confirmRefund
        }, {
          default: _withCtx(() => [
            _createTextVNode("申请退保")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})